import React from "react";

export const DeletePromoCodeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="13"
      viewBox="0 0 11 13"
      fill="none"
    >
      <path
        d="M10.5 2.36364H8V0.590909C8 0.43419 7.94732 0.28389 7.85355 0.173073C7.75979 0.0622563 7.63261 0 7.5 0H3.5C3.36739 0 3.24021 0.0622563 3.14645 0.173073C3.05268 0.28389 3 0.43419 3 0.590909V2.36364H0.5C0.367392 2.36364 0.240215 2.42589 0.146447 2.53671C0.0526784 2.64753 0 2.79783 0 2.95455C0 3.11126 0.0526784 3.26156 0.146447 3.37238C0.240215 3.4832 0.367392 3.54545 0.5 3.54545H1.0585L2.004 12.4824C2.01911 12.6253 2.07785 12.7567 2.16918 12.852C2.26051 12.9473 2.37815 13 2.5 13H8.5C8.62185 13 8.73949 12.9473 8.83082 12.852C8.92215 12.7567 8.98089 12.6253 8.996 12.4824L9.9415 3.54545H10.5C10.6326 3.54545 10.7598 3.4832 10.8536 3.37238C10.9473 3.26156 11 3.11126 11 2.95455C11 2.79783 10.9473 2.64753 10.8536 2.53671C10.7598 2.42589 10.6326 2.36364 10.5 2.36364ZM4 1.18182H7V2.36364H4V1.18182ZM8.0585 11.8182H2.9415L2.0665 3.54545H8.9335L8.0585 11.8182Z"
        fill="white"
      />
    </svg>
  );
};
